import { colors } from '@mui/material';
import type { ColorValue, PaletteShade } from '~/global.style';

export default function getIndustryColor(
  industries_id: number,
  shade: PaletteShade = 100
): ColorValue {
  const colorChoices = [
    colors.teal[shade],
    colors.amber[shade],
    colors.purple[shade],
    colors.green[shade],
    colors.orange[shade],
    colors.pink[shade],
  ];
  const index = Math.floor(industries_id % colorChoices.length);
  return colorChoices[index] || colors.grey['100'];
}
